import React from "react";

import { useTranslation } from "react-i18next";

import { IPeriodStatisticsChartData } from "@data-types/sport-stats/SportStatsTypes";
import { EventStatsGraph } from "@features/offer/shared/statistics";
import { highlightTeam } from "@utils/offer";
import classnames from "classnames";

export function EventStatsGroupBody(props: {
	statsData: IPeriodStatisticsChartData[];
	isExpanded: boolean;
}) {
	const { isExpanded, statsData } = props;

	const { t } = useTranslation();

	const setGraphName = (title: string, key: string | null) => {
		const matchStatName = t(title, { defaultValue: "" });

		if (key != null) {
			return `${matchStatName} (${key})`;
		}

		return matchStatName;
	};

	if (!isExpanded) {
		return null;
	}

	return (
		<div
			className={classnames("card__body", {
				"is-collapsed": !isExpanded,
			})}
		>
			<div className="card card--borderless card--stats">
				<div className="card--stats__body">
					{statsData.map((stat, index) => (
						<EventStatsGraph
							key={index}
							info={t(stat.infoSection, { defaultValue: "" })}
							graphName={setGraphName(stat.title, stat.key)}
							data={stat.data}
							max={stat.max}
							removeValues
							highlightTeam={highlightTeam(stat.data)}
						/>
					))}
				</div>
			</div>
		</div>
	);
}
